import { render, staticRenderFns } from "./ProjectTaskTemplateDetailListing.vue?vue&type=template&id=22f41152&"
import script from "./ProjectTaskTemplateDetailListing.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTemplateDetailListing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTaskTemplateDetailListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports